import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterService {
  readonly filters = signal<Record<string, string[]>>({});

  setFilter(id: string, values: string[] | string): void {
    // Normalize values to array format
    let normalized: string[];
    if (Array.isArray(values)) {
      normalized = values;
    } else if (values) {
      normalized = [values];
    } else {
      normalized = [];
    }
    
    const next = { ...this.filters(), [id]: normalized };
    this.filters.set(next);
  }

  toggleValue(id: string, value: string): void {
    const current = this.filters()[id] || [];
    const exists = current.includes(value);
    const next = exists ? current.filter(v => v !== value) : [...current, value];
    this.setFilter(id, next);
  }

  clear(): void {
    this.filters.set({});
  }
}


